module.exports = __webpack_public_path__ + "static/media/spanish-past-tense-table-2.ba211222.JPG";